import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Paper, Table, TableCell, TableContainer, TableRow, Button, Typography } from '@material-ui/core';
import useStyles from '@jumbo/components/Mantenimiento/MantenimientoStyle';
import NoRecordFound from '@jumbo/components/ListadoEjecucion/NoRecordFound';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import { getComparator, stableSort } from '@jumbo/utils/tableHelper';
import Toolbar from '@material-ui/core/Toolbar';
import CmtSearch from '@coremat/CmtSearch';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableUtils from '@jumbo/utils/TableUtils';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import { useDispatch, useSelector } from 'react-redux';
import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import Pickersinapp from 'routes/Ejecucion/utils/Pickersinapp';
import Grid from '@material-ui/core/Grid';
import useForm from '@jumbo/utils/useForm';
import axios from '@jumbo/constants/axios';
import { fetchError, fetchSuccess } from '../../redux/actions/Common';
import Swal from 'sweetalert2';
import { EliminarSolicitudConsulta} from '../../redux/actions/Herramientas';

const headCells = [
  {
    id: 'opcionSolicitada',
    numeric: false,
    disablePadding: false,
    label: 'Opción Solicitada',
  },
  {
    id: 'solicitadoPor',
    numeric: false,
    disablePadding: false,
    label: 'Solicitado Por',
  },
  {
    id: 'fechaGeneracionPresupuesto',
    numeric: false,
    disablePadding: false,
    label: 'Fecha Generación Presupuesto',
  },
  {
    id: 'Creado ',
    numeric: false,
    disablePadding: false,
    label: 'Fech Creación',
  },
];

function TableHeadFormulario({ classes, order, orderBy, onRequestSort }) {
  const onSortOrderChange = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={onSortOrderChange(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="right">Acción</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default function InformesForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { usuarioID } = useSelector(({ auth }) => auth.authUser);
  const [Solicitudes, setSolicitudes] = useState([]);
  const [data, setData] = useState([]);
  const [orderBy, setOrderBy] = React.useState('descripcion');
  const [order, setOrder] = React.useState('asc');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const { form, setForm } = useForm({
    UsuarioID: usuarioID,
    FormAppID: null,
    FechaGuardadaInicialDummy: 'na',
    FechaGuardadaFinalDummy: 'na',
    FechaGeneracionPresupuestoInicialDummy: 'na',
    FechaGeneracionPresupuestoFinalDummy: 'na',
  });

  const BuscarSolicitud = params => {
    axios
      .post('SolicitudEjecucion/solguardadalist', params)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          setSolicitudes(data.data);
        } else {
          dispatch(fetchError('Esta acción no pudo realizarse.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Esta acción no pudo realizarse.'));
      });
  };

  useEffect(() => {
    BuscarSolicitud(form);
  }, [dispatch, form]);

  useEffect(() => {
    function getFilteredArray(entities, _searchTerm) {
      if (_searchTerm.length === 0) {
        return Solicitudes;
      }
      return TableUtils.filterArrayByString(Solicitudes, _searchTerm);
    }
    if (Solicitudes) {
      setData(getFilteredArray(Solicitudes, searchTerm));
    }
  }, [Solicitudes, searchTerm]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrderBy(property);
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <PageContainer heading="Presupuestos de Cobros">
      <CmtCard className={classes.CmtCard}>
        <CmtCardContent>
          <Grid container spacing={2} direction="row" wrap="nowrap" alignItems="center" justifyContent="center">
            <Grid item>
              <Pickersinapp
                label="Guardado Desde"
                value={form.FechaGuardadaInicialDummy === 'na' ? null : form.FechaGuardadaInicialDummy}
                onChange={date => {
                  date !== null
                    ? setForm(_.set({ ...form }, 'FechaGuardadaInicialDummy', `${date.format('YYYYMMDD')}`))
                    : setForm(_.set({ ...form }, 'FechaGuardadaInicialDummy', 'na'));
                }}
                style={{ minWidth: 200 }}
              />
            </Grid>

            <Grid item>
              <Pickersinapp
                label="Guardado Hasta"
                value={form.FechaGuardadaFinalDummy === 'na' ? null : form.FechaGuardadaFinalDummy}
                onChange={date => {
                  date !== null
                    ? setForm(_.set({ ...form }, 'FechaGuardadaFinalDummy', `${date.format('YYYYMMDD')}`))
                    : setForm(_.set({ ...form }, 'FechaGuardadaFinalDummy', 'na'));
                }}
                style={{ minWidth: 200 }}
              />
            </Grid>

            <Grid item>
              <Pickersinapp
                label="Presupuesto Desde"
                value={
                  form.FechaGeneracionPresupuestoInicialDummy === 'na' ? null : form.FechaGeneracionPresupuestoInicialDummy
                }
                onChange={date => {
                  date !== null
                    ? setForm(_.set({ ...form }, 'FechaGeneracionPresupuestoInicialDummy', `${date.format('YYYYMMDD')}`))
                    : setForm(_.set({ ...form }, 'FechaGeneracionPresupuestoInicialDummy', 'na'));
                }}
                style={{ minWidth: 200 }}
              />
            </Grid>

            <Grid item>
              <Pickersinapp
                label="Presupuesto Hasta"
                value={form.FechaGeneracionPresupuestoFinalDummy === 'na' ? null : form.FechaGeneracionPresupuestoFinalDummy}
                onChange={date => {
                  date !== null
                    ? setForm(_.set({ ...form }, 'FechaGeneracionPresupuestoFinalDummy', `${date.format('YYYYMMDD')}`))
                    : setForm(_.set({ ...form }, 'FechaGeneracionPresupuestoFinalDummy', 'na'));
                }}
                style={{ minWidth: 200 }}
              />
            </Grid>

            <Grid item>
              <Button
                onClick={() => BuscarSolicitud(form)}
                size="small"
                className={classes.button}
                variant="contained"
                style={{ minWidth: 100 }}>
                Buscar
              </Button>
            </Grid>
          </Grid>
        </CmtCardContent>
      </CmtCard>

      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Toolbar className={classes.roottoolbar}>
            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
              Listado de Solicitudes
            </Typography>
            <React.Fragment>
              <CmtSearch onChange={e => setSearchTerm(e.target.value)} value={searchTerm} border={false} onlyIcon />
            </React.Fragment>
          </Toolbar>

          <TableContainer className={classes.containersolicitudes}>
            <Table stickyHeader className={classes.table} aria-labelledby="tableTitle" aria-label="sticky enhanced table">
              <TableHeadFormulario classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />

              <TableBody>
                {!!data.length ? (
                  stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow hover tabIndex={-1} key={row.formAppID}>
                        <TableCell>{row.opcionSolicitada}</TableCell>
                        <TableCell>{row.solicitadoPor}</TableCell>
                        <TableCell>{row.fechaGeneracionPresupuesto}</TableCell>
                        <TableCell>{row.createdOn}</TableCell>
                        <TableCell align="right">
                          <Button
                            style={{ marginRight: 10 }}
                            size="small"
                            className={classes.button}
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                              if (row.archivosNombreDescargar) {
                                axios
                                  .get(`SolicitudEjecucion/solguardadafiledownlget/${row.solicitudGuardadaID}`)
                                  .then(response => {
                                    dispatch(fetchSuccess(''));
                                    console.log(response);
                                  })
                                  .catch(error => {
                                    dispatch(fetchError(error.response.data));
                                  });
                                window.open(row.archivosNombreDescargar, null);
                              }
                            }}>
                            Descargar
                          </Button>
                          <Button size='small' className={classes.buttonerror} variant="contained" color='secondary'
                                      onClick={() => {
                                            Swal.fire({
                                              title: '¿Estás seguro(a) de Eliminar?',
                                              text: '¡No podrás recuperar este cambio!',
                                              icon: 'warning',
                                              showCancelButton: true,
                                              confirmButtonColor: "red",
                                              confirmButtonText: 'Si, Eliminar',
                                              cancelButtonText: 'No, Mantener',
                                              }).then((result) => {
                                              if (result.value) {
                                               
                                                axios
                                                .post(`SolicitudEjecucion/solguardadadel/${row.solicitudGuardadaID}/${usuarioID}`)
                                                .then(response => {
                                                  dispatch(fetchSuccess(''));
                                                  BuscarSolicitud(form);
                                                })
                                                .catch(error => {
                                                  dispatch(fetchError(error.response.data));
                                                });

                                              } else if (result.dismiss === Swal.DismissReason.cancel) {
                                                Swal.fire(
                                                'Cancelado',
                                                'No se realizó este cambio :)',
                                                'error'
                                                )
                                              }
                                              })
                                      }}
                                    > Eliminar </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow style={{ height: 53 * 6 }}>
                    <TableCell colSpan={7} rowSpan={10}>
                      <NoRecordFound>No se han encontrado registros.</NoRecordFound>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            labelRowsPerPage="Filas por página"
          />
        </Paper>
      </div>
    </PageContainer>
  );
}
